import axiosInstance from './axiosInstance';

export const fetchAuctionCompaniesAPI = async (email: string) => {
    const response = await axiosInstance.get(`/Auth/GetTenants`, {
        params: {
            username: email,
        },
    });
    // console.log("response", response)
    return response.data.map((tenant: string) => ({
        value: tenant,
        label: tenant,
    }));
};

export const loginUserAPI = async (email: string, password: string, auctionCompany: string) => {
    const response = await axiosInstance.post(`/Auth/Login`, {
        User_Name: email,
        Password: password,
        Tenant: auctionCompany,
    });
    return {token: response.data.token, refreshToken: response.data.refresh_token, userName: response.data.userName, userId: response.data.user_ID};
};

export const getRefreshTokenAPI = async (RefreshToken: string, Tenant: string) => {
    const response = await axiosInstance.post(`/Auth/Refresh`, {
        RefreshToken,
        Tenant
    });
    return {token: response.data.token, refreshToken: response.data.refresh_token};
};
